import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MATERIALES_APOYO } from '@env';

@Injectable()
export class MaterialesApoyoProvider {

  constructor(public http: HttpClient) {
  }

  getAll(area: string): Promise<any> {
    return this.http.get( `${MATERIALES_APOYO.GET}${area}`).toPromise();
  }

  getOne(material: string): Promise<any> {
    return this.http.get( `${MATERIALES_APOYO.GET_ONE}${material}`).toPromise();
  }

  marcarComoVisto(area: string, jugador: string, material: string): Promise<any> {
    return this.http.post( `${MATERIALES_APOYO.VISTO}`, {area, material, jugador}).toPromise();
  }

  like(area: string, jugador: string, material: string ): Promise<any> {
    return this.http.post( `${MATERIALES_APOYO.LIKE}`, {area, material, jugador}).toPromise();
  }
  
  isLiked(area: string, jugador: string , material: string): Promise<any> {
    return this.http.get( `${MATERIALES_APOYO.LIKE}${area}/${material}/${jugador}`).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/materiales-apoyo/materiales-apoyo.ts